import React, { memo } from "react";
import { Row, Col } from "antd";
import SelectDate from "./SelectDate";
import InputLot from "./InputLot";
import SelectAmount from "./SelectAmount";
import InputDescription from "./InputDescription";

const Index = ({ disabled }) => (
  <>
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <SelectDate type="mfg_date" disabled={disabled} />
      </Col>
      <Col span={12}>
        <SelectDate type="exp_date" disabled={disabled} />
      </Col>
    </Row>
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <InputLot disabled={disabled} />
      </Col>
      <Col span={12}>
        <SelectAmount disabled={disabled} />
      </Col>
    </Row>
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <InputDescription disabled={disabled} />
      </Col>
    </Row>
  </>
);

export default memo(Index);
